import React from "react";

import { IgListItemButton } from "@intelligems/ig-theme";
import { DeviceType } from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import { deviceTypeList } from "./utils";

interface DeviceProps {
  onClick: (arg1: any, arg2: any) => void;
  deviceType?: DeviceType | null;
  buttonFontSize?: string;
}

export const Device = ({
  deviceType,
  onClick,
  buttonFontSize,
}: DeviceProps) => {
  const selectedCard = (selectedDeviceType: string): boolean => {
    return deviceType === selectedDeviceType;
  };

  return (
    <Grid container spacing={2} direction={"row"}>
      {deviceTypeList.map((deviceType) => (
        <Grid item xs={4} key={deviceType.key}>
          <IgListItemButton
            buttonFontSize={buttonFontSize}
            label={deviceType.label}
            onClick={() => {
              onClick(deviceType.key, "deviceType");
            }}
            selected={selectedCard(deviceType.key)}
          />
        </Grid>
      ))}
    </Grid>
  );
};
